import { EMAIL_PATTERN } from './ui/dialog';

export type Locale = 'de' | 'en';

export interface FeedbackOptions {
  /** Base URL of the feedback server, e.g. "https://feedback.bytax.de" (no trailing slash) */
  endpoint: string;
  /** Public per-project ingest token ("fbk_…") */
  token: string;
  /** UI language, default "de" */
  locale?: Locale;
  /** Capture element screenshot, default true */
  screenshot?: boolean;
  /** z-index of the widget host, default 2147483000 */
  zIndex?: number;
  /** Extra key/value context sent with every feedback (e.g. { appVersion: "1.2.0" }) */
  metadata?: Record<string, string>;
  /** DEV ONLY: bypass the reviewer-key gate and always render */
  forceVisible?: boolean;
  /** Known reviewer email — skips the dialog's email field */
  reporterEmail?: string;
}

export interface ResolvedOptions {
  endpoint: string;
  token: string;
  locale: Locale;
  screenshot: boolean;
  zIndex: number;
  metadata: Record<string, string> | undefined;
  forceVisible: boolean;
  reporterEmail: string | undefined;
}

export interface FeedbackController {
  destroy(): void;
  /** true when the reviewer gate passed and the launcher is mounted */
  isMounted(): boolean;
}

export function resolveOptions(options: FeedbackOptions): ResolvedOptions {
  // Invalid config-supplied emails fall back to undefined rather than being
  // forwarded as-is — the dialog's own (optional) email field then acts as
  // the fallback instead of a value that would 400 at ingest.
  const trimmedEmail = options.reporterEmail?.trim();
  const reporterEmail = trimmedEmail && EMAIL_PATTERN.test(trimmedEmail) ? trimmedEmail : undefined;
  return {
    endpoint: options.endpoint.replace(/\/+$/, ''),
    token: options.token,
    locale: options.locale ?? 'de',
    screenshot: options.screenshot ?? true,
    zIndex: options.zIndex ?? 2147483000,
    metadata: options.metadata,
    forceVisible: options.forceVisible ?? false,
    reporterEmail,
  };
}
